export enum ENV {
  DEVELOPMENT = "development",
  PROD = "production",
  TEST = "test",
}

// NOTE - this does not include any api urls, since they exist in the financial-advisory/config library
export type ApplicationConfig = {
  ENV: ENV;
  AUTH0: {
    AUDIENCE: string;
    CLIENT_ID: string;
    DOMAIN: string;
  };
  DEMO_ORGANISATION_ID: string;
  LLOYDS_ORGANISATION_ID: string;
  NATWEST_ORGANISATION_ID: string;
};
